var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center mb-20 mb-md-30"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("경매결과")])]), _c('div', {
    staticClass: "tab-wrap"
  }, [_c('v-tabs', {
    staticClass: "tab tab--inline tab--underline-inline",
    attrs: {
      "centered": "",
      "show-arrows": "",
      "center-active": ""
    }
  }, [_c('v-tab', {
    attrs: {
      "to": "/auction-results",
      "exact": ""
    }
  }, [_c('span', [_vm._v("전체")])]), _c('v-tab', {
    attrs: {
      "to": "/auction-results/A",
      "exact-path": ""
    }
  }, [_c('span', [_vm._v("Online Auction")])]), _c('v-tab', {
    attrs: {
      "to": "/auction-results/B",
      "exact-path": ""
    }
  }, [_c('span', [_vm._v("After Sale Online")])])], 1)], 1), _c('div', {
    staticClass: "my-n14 my-md-n20"
  }, [_c('v-row', _vm._l(_vm.programs, function (program) {
    return _c('v-col', {
      key: program._id,
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('auction-results-program', {
      attrs: {
        "program": program
      }
    })], 1);
  }), 1)], 1), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    staticClass: "mt-8 mb-16",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }